import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { Typography } from "antd";
const { Text } = Typography;

const AttributesContainer = styled.div`
  display: flex;
  .labelContainer {
    display: flex;
    flex-direction: column;
    padding-left: 5px;
    padding-right: 5px;
  }
  .label {
    padding-bottom: 5px;
    line-height: 16px;
  }
`;

const AttributesList = ({ attributes }) => {
  return (
    <AttributesContainer className="attributes">
      <div className="labelContainer">
        {Object.keys(attributes).map((key) => {
          return (
            <div key={key} className="label">
              {<FormattedMessage id={key} />}:
            </div>
          );
        })}
      </div>
      <div className="labelContainer">
        {Object.keys(attributes).map((key) => {
          return (
            <Text key={key} className="label" type="secondary">
              {attributes[key]}
            </Text>
          );
        })}
      </div>
    </AttributesContainer>
  );
};

export default AttributesList;
